<template>
  <o-dropdown
    placement="right-start"
    :trigger="['hover', 'click']"
    :clickaway="false"
    :auto-hide-parent="autoHideParent"
    :portal="false"
    :modifiers="modifiers"
    :arrow="false"
    class="w-full"
  >
    <div class="w-full py-2 px-3 flex items-center justify-between transition duration-200 ease-in-out cursor-pointer rounded-md hover:bg-white/20">
      <div
        class="flex items-center"
        :class="{
          'py-2px' : !icon
        }"
      >
        <div v-if="icon" class="pr-3 leading-none ">
          <component :is="iconType" :icon="icon" :src="icon" :size="iconSize" class="max-w-4" />
        </div>
        <div class="text-left pr-2">
          <p class="text-sm leading-none">
            <slot>
              {{ name }}
            </slot>
          </p>
          <p v-if="description" class="text-sm opacity-60 leading-none mt-1">
            <slot name="description">
              {{ description }}
            </slot>
          </p>
        </div>
      </div>
      <o-icon icon="chevronRight" :size="12" class="opacity-60" />
    </div>

    <template #content>
      <slot name="content" />
    </template>
  </o-dropdown>
</template>

<script setup lang="ts">
import ODropdown from './Dropdown.vue'
import { icons } from '@/components/elements/Icon.vue'

interface Props {
  name?: string | null
  description?: string | null
  icon?: string | string[] | null
  iconSize?: number
  autoHideParent?: boolean
  modifiers?: any[]
}

const props = withDefaults(defineProps<Props>(), {
  name: null,
  description: null,
  icon: null,
  iconSize: 14,
  autoHideParent: true,
  modifiers: () => [
    {
      name: 'offset',
      options: {
        offset: [0, 0],
      },
    },
  ],
})

const iconType = computed(() => {
  const icon = (icons as any)?.[props.icon as string]
  return icon ? 'o-icon' : 'img'
})

</script>
